export default {
  grDate: 'GR 日期',
  plants: '仓库',
  latestValidationResult: '最新对比结果',
  actualValidationResult: '实际对比结果',
  cartonNumber: '箱号',
  asnDn: 'ASN',
  asnDnSku: 'ASN SKU',
  specialSku: '特殊SKU',
  asnDnQty: 'ASN 件数',
  scanQty: '扫描件数',
  deltaQty: 'Delta 件数',
  productName: '产品名称',
  latestSystemValidationResult: '最新对比结果',
  specialType: '特殊产品类型',
  exceptionType: '异常类型',
  sku: 'SKU',
  qty: '件数',
  accurate: '准确',
  Unexpected: '未知箱号',
  epcShortage: 'EPC少件',
  epcOverage: 'EPC多件',
  upcMismatched: 'UPC混件',
  manualConfirm: '人工确认',
  newCarton: '新箱',
  lastScannedDevice: '最后扫描设备',
  lastScanTime: '最后扫描时间',
  misMatchedSku: '混件SKU',
  unknownSku: '未知SKU',
  misMatchedQty: '混件件数',
  validationResult: '对比结果',
  ttlCartonQty: '总箱数',
  mislabelingCartonQty: '串标箱数',
  total: '合计',
  opitionError: '箱号、ASN 或 GR 日期三者至少填一项!',
  cartonNumberMaxError: '箱号最多支持输入 50 个值.',
  asnDnMaxError: 'ASN最多支持输入 50 个值.',
  cartonPe: '箱 PE',
  // OB 报表专用，其余文案与 IB 共用
  obGrDate: 'GI 日期',
  obAsnDn: 'Packlist',
  obAsnDnSku: 'GI SKU',
  obAsnDnQty: 'GI 件数',
  obOpitionError: '箱号、Packlist 或 GI 日期三者至少填一项!',
  obAsnDnMaxError: 'Packlist最多支持输入 50 个值.'
}
